import MotionController from "../lib/motion_controller"
import { gsap } from "../lib/motion"

// Ties a single tween to scroll position (parallax, tilt-to-flat, drift).
//   data-controller="scrub"
//   data-scrub-from-value='{"rotationX":12,"scale":0.94}'
//   data-scrub-to-value='{"rotationX":0,"scale":1}'
//   data-scrub-trigger-value="#hero"   (defaults to the element)
//   data-scrub-desktop-only-value="true"
export default class extends MotionController {
  static values = {
    from: Object,
    to: Object,
    trigger: String,
    start: { type: String, default: "top bottom" },
    end: { type: String, default: "bottom top" },
    smooth: { type: Number, default: 0.6 },
    desktopOnly: { type: Boolean, default: true }
  }

  animate({ desktop, mobile }) {
    if (!(desktop || (mobile && !this.desktopOnlyValue))) return

    const trigger = this.hasTriggerValue ? this.element.closest(this.triggerValue) || this.element : this.element
    gsap.fromTo(this.element, this.fromValue, {
      ...this.toValue,
      ease: "none",
      scrollTrigger: {
        trigger,
        start: this.startValue,
        end: this.endValue,
        scrub: this.smoothValue
      }
    })
  }
}
